<button mat-button color="primary" class="back-button"
  (click)="goBackEmitter.emit()">
  <img class="exit-icon" src="assets/icons/exit.svg" />
  <span>Volver</span>
</button>